module.exports = __webpack_public_path__ + "6f8eacd6.otf";